import axios from 'axios';
import { useQuery } from 'react-query';

const useFindProject = (projectId) => {
    const { data, isLoading } = useQuery('project', async () => {
        return (await axios.get(`/projects/${projectId}`)).data;
    },
        { refetchOnMount: true });

    return {
        project: data,
        isLoading,
    };
};

export default useFindProject;
